import { render, staticRenderFns } from "./JobButton.vue?vue&type=template&id=2f65f4dd"
import script from "./JobButton.vue?vue&type=script&lang=js"
export * from "./JobButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports